import { Box } from "@material-ui/core";
import { useEffect, useState } from "react";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllContacts = () => {
  const classes = useAdminStyles();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios.get("/api/getcontactdata", { headers: { headKey: headKey } }).then(
      (res) => {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#contacts_table").DataTable({
            destroy: true,
            scrollX: true,
            order: [[0, "desc"]],
          });
        });
      }
    );
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Contact History - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Records"
        title="Contact enquiries"
        subtitle={`Total enquiries received: ${data.length}`}
      />

      <Box className={classes.tableWrap}>
        <table id="contacts_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Subject</th>
              <th>Message</th>
              <th>Received</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.id}>
                <td>{da.id}</td>
                <td style={{ fontWeight: 600 }}>{da.name}</td>
                <td>{da.email}</td>
                <td>{da.number}</td>
                <td>{da.subject}</td>
                <td style={{ maxWidth: 320 }}>{da.message}</td>
                <td>{da.date_time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
